<script>
  import {
    Button,
    Modal,
    ModalBody,
    ModalFooter,
    ModalHeader,
    Input,
    Badge,
    Spinner,
    Table
  } from "sveltestrap";
  import Icon from "svelte-awesome";
  import FloorsTable from "./containers/FloorsTable.svelte";
  import AddFloorModal from "./AddFloorModal.svelte";
  import DeleteFloorModal from "./DeleteFloorModal.svelte";
  import AddContactModal from "./AddContactModal.svelte";
  import JobContactsContainer from "./containers/JobContactsContainer.svelte";
  import AddFloorResource from "./containers/AddFloorResource.svelte";
  import DeleteProjectManagerModal from "./DeleteProjectManagerModal.svelte";
  import EditFloorsModal from "./EditFloorsModal.svelte";
  import AddMultipleFloorsModal from "./AddMultipleFloorsModal.svelte";
  import ConfirmationDialog from "./ConfirmationDialog.svelte";
  import { edit, userPlus, eye } from "svelte-awesome/icons";
  import { onMount, createEventDispatcher, getContext } from "svelte";
  import axios from "axios";
  import { format } from 'date-fns';

  export let Priority;
  export let jobDetail = {};
  export let teamId;
  export let isReadOnly = false;
  export let floors;
  export let projectManagerName;
  export let deliverableItemSequenceNo = 0;

  let statusOptions = [];
  let priorityOptions = [];
  let floorStatusOptions = [];

  let open = false;
  let toggle = () => (open = !open);

  const { getAvailableDeliverableItems, getJobCards } = getContext('jobBoard');

  let isFetching = true;
  let isFetchingFloors = true;
  let isFetchingContacts = true;
  let contacts = [];
  let projectManager;
  let openAddContact = false;
  let toggleAddContact = () => (openAddContact = !openAddContact);
  let deliverableId = jobDetail.DeliverableItemId;
  let priority = jobDetail.Priority;
  let status = jobDetail.Status;
  let projectNotes = jobDetail.ProjectNotes;
  let deliverableComments = jobDetail.Notes;
  let floorDetails;
  ///field variables
  let startdate = !!jobDetail.StartDate ? format(new Date(jobDetail.StartDate), 'MM/dd/yyyy') : '';
  let enddate = !!jobDetail.EndDate ? format(new Date(jobDetail.EndDate), 'MM/dd/yyyy') : '';

  ///toggle variabales
  let editJob = isReadOnly;
  let toggle_edit = () => (editJob = !editJob);
  let openAddFloor = false;
  let toggleAddFloor = () => (openAddFloor = !openAddFloor);
  let dueDate = !!jobDetail.DueDate ? format(new Date(jobDetail.DueDate), 'MM/dd/yyyy') : '';
  $: dueDateHtmlFormat = !!dueDate ? format(new Date(dueDate), 'yyyy-MM-dd') : '';
  let floorStatus = [];
  let saving = false;
  let floorIDs;
  let floorName = "";
  let floorLabel = "";
  let floorOrder = 0;
  let floorNotes = "";
  //Delete ProjectManager
  let openDeleteProjectManager = false;
  let toggleDeleteProjectManager = () =>
    (openDeleteProjectManager = !openDeleteProjectManager);
  //Delete Floor Listing
  let openDeleteFloor = false;
  let toggleDeleteFloor = () => (openDeleteFloor = !openDeleteFloor);

  let openEditFloor = false;
  let toggleEditFloor = () => (openEditFloor = !openEditFloor);

  let addMultipleFloorsModal = {};

  let isAutoAddFloorsConfirmationDialogOpen = false;
  let toggleAutoAddFloorsConfirmationDialog = () => (isAutoAddFloorsConfirmationDialogOpen = !isAutoAddFloorsConfirmationDialogOpen);

  const formOptions = getContext('formOptions');

  $: floorsCount = (floors || []).length;
  $: completedFloorsCount = (floors || []).filter(e => e.Status === '100000004').length;

  const dispatch = createEventDispatcher();
  const MIN_SEQUENCE_NUMBER_TO_ALLOW_STATUS_EDITING = 10;

  onMount(() => {
    //getContacts(data.DeliverableId);
    //getProjectManager(jobDetail.JobID);
  });

  export function openModal(deliverableItemId, jobId, initialData) {
    open = true;
    jobDetail = initialData || {};
    loadData();
  }

  function loadData() {
    getJobDetail();
    getPriorityStatuses();
    getStatusOptions();
    getFloorStatuses();
    getContacts();
    getFloors();
  }

  function getJobDetail() {
    isFetching = true;
    axios.get(`/jobboardapi/GetDeliverableById?deliverableId=${jobDetail.DeliverableId}`)
      .then(function(response) {
        let res = response.data;
        jobDetail = { ...jobDetail, ...res };
        if (!!jobDetail.StartDate) {
          startdate = format(new Date(jobDetail.StartDate), 'MM/dd/yyyy');
        }

        if (!!jobDetail.EndDate) {
          enddate = format(new Date(jobDetail.EndDate), 'MM/dd/yyyy');
        }

        if (!!jobDetail.DueDate) {
          dueDate = format(new Date(jobDetail.DueDate), 'MM/dd/yyyy');
        }

        projectManagerName = jobDetail.ProjectManager;
      })
      .catch(console.warn)
      .finally(function (params) {
        isFetching = false;
      });
  }

  function getPriorityStatuses() {
    const priorityOptionsCache = localStorage.getItem('job_priority_options');
    if (!!priorityOptionsCache) {
      priorityOptions = JSON.parse(priorityOptionsCache || '[]');
      return;
    }

    axios.get("/jobboardapi/getpriority")
      .then(res => {
        priorityOptions = res.data || priorityOptions;
        localStorage.setItem('job_priority_options', JSON.stringify(priorityOptions));
      })
      .catch(console.warn);
  }

  function getStatusOptions() {
    const statusOptionsCache = localStorage.getItem('job_status_options');
    if (!!statusOptionsCache) {
      statusOptions = JSON.parse(statusOptionsCache || '[]');
      return;
    }

    axios.get("/jobboardapi/getstatus")
      .then(res => {
        statusOptions = res.data || statusOptions;
        localStorage.setItem('job_status_options', JSON.stringify(statusOptions));
      })
      .catch(console.warn);
  }

  function getFloorStatuses() {
    const floorStatusOptionsCache = localStorage.getItem('job_floor_status_options');
    if (!!floorStatusOptionsCache) {
      floorStatusOptions = JSON.parse(floorStatusOptionsCache || '[]');
      return;
    }

    axios.get("/jobboardv2api/GetFloorStatusOptionSet")
      .then(res => {
        floorStatusOptions = res.data || floorStatusOptions;
        localStorage.setItem('job_floor_status_options', JSON.stringify(floorStatusOptions));
      })
      .catch(console.warn);
  }

  async function UpdateJobs() {
    saving = true;
    var bodyFormData = new FormData();
    for (let i = 0; i < floorStatus.length; i++) {
      bodyFormData.append(`FloorStatus[${i}].FloorId`, floorStatus[i].FloorId);
      bodyFormData.append(`FloorStatus[${i}].Value`, floorStatus[i].Value);
    }

    bodyFormData.set("JobID", jobDetail.JobID);
    bodyFormData.set("DeliverableId", jobDetail.DeliverableId);
    bodyFormData.set("Status", jobDetail.Status);
    if (!!dueDate) {
      bodyFormData.set("DueDate", htmlDateToLocale(dueDate));
    }

    bodyFormData.set("StartDate", startdate);
    bodyFormData.set("EndDate", enddate);
    bodyFormData.set("DeliverableItemId", jobDetail.DeliverableItemId);
    bodyFormData.set("Priority", jobDetail.Priority);
    bodyFormData.set("Notes", jobDetail.Notes);
    bodyFormData.set("NoOfCompletedFloors", completedFloorsCount);
    bodyFormData.set("NoOfFloors", floorsCount);

    await axios({
      method: "post",
      url: "/JobBoardV2Api/SaveJobDetails",
      data: bodyFormData,
      headers: { "Content-Type": "multipart/form-data" }
    })
      .then(function(response) {
        floorStatus = [];
        saving = false;
        toggle();
      })
      .then(function(response) {
        dispatch('jobUpdated');
      })
      .catch(console.warn);
  }

  function htmlDateToLocale(htmlDateString) {
    return format(new Date(htmlDateString), 'MM/dd/yyyy');
  }

  function getContacts(deliverableId) {
    isFetchingContacts = true;
    axios
      .get(`/resourceapi/retrieveallresourceassigned?deliverableId=${jobDetail.DeliverableId}`)
      .then(function(response) {
        contacts = response.data;
      })
      .then(function () {
        return axios.get(`/resourceapi/getrelatedcontacts?deliverableId=${jobDetail.DeliverableId}`);
      })
      .then(function(response) {
        contacts = [...contacts, ...response.data];
      })
      .catch(console.warn)
      .finally(function (params) {
        isFetchingContacts = false;
      });
  }

  function handleCancel() {
    let deliverableId = jobDetail.DeliverableItemId;
    let priority = jobDetail.Priority;
    let status = jobDetail.Status;
    let projectNotes = jobDetail.ProjectNotes;
    let deliverableComments = jobDetail.Notes;
    ///field variables
    let startdate =
      new Date(jobDetail.StartDate).getFullYear() +
      "-" +
      (new Date(jobDetail.StartDate).getMonth() < 10
        ? "0" + (new Date(jobDetail.StartDate).getMonth() + 1)
        : new Date(jobDetail.StartDate).getMonth() + 1) +
      "-" +
      (new Date(jobDetail.StartDate).getDate() < 10
        ? "0" + new Date(jobDetail.StartDate).getDate()
        : new Date(jobDetail.StartDate).getDate());

    let enddate =
      new Date(jobDetail.EndDate).getFullYear() +
      "-" +
      (new Date(jobDetail.EndDate).getMonth() < 10
        ? "0" + (new Date(jobDetail.EndDate).getMonth() + 1)
        : new Date(jobDetail.EndDate).getMonth() + 1) +
      "-" +
      (new Date(jobDetail.EndDate).getDate() < 10
        ? "0" + new Date(jobDetail.EndDate).getDate()
        : new Date(jobDetail.EndDate).getDate());
    editJob = false;
  }

  function AddFloor() {
    floorLabel = floorName;

    var bodyFormData = new FormData();
    bodyFormData.set("PropertyId", jobDetail.PropertyId);
    bodyFormData.set("Completed", false);
    bodyFormData.set("Notes", floorNotes);
    bodyFormData.set("FloorOrder", floorOrder);
    bodyFormData.set("FloorName", floorName);
    bodyFormData.set("FloorLabel", floorLabel);
    axios({
      method: "post",
      url: "/jobboardapi/AddFloor",
      data: bodyFormData,
      headers: { "Content-Type": "multipart/form-data" }
    })
      .then(function(response) {
        floorNotes = "";
        floorOrder = 0;
        floorName = "";
        floorLabel = "";
        onFloorAdded();
      })
      .catch(console.warn);
  }

  function handleClose() {
    toggle();
    editJob = false;
  }

  function handleChangeStartDate(e) {
    startdate = e.target.value;
  }
  let deletefloor_id = "";
  let deletefloor_name = "";

  function handleDeleteFloor(id, name) {
    toggleDeleteFloor();
    deletefloor_id = id;
    deletefloor_name = name;
  }
  function handleEditFloor(floor) {
    toggleEditFloor();
    floorDetails = floor;
  }
  function handleChangeEndDate(e) {
    enddate = e.target.value;
  }
  function handleChangeContacts() {
    contacts = null;
    getContacts(jobDetail.DeliverableId);
    getJobDetail();
    getProjectManager(jobDetail.JobID);
    getFloors();
  }

  let newcompleted = [];

  function getProjectManager(jobId) {
    axios
      .get("/jobboardapi/GetProjectManager?jobId=" + jobId)
      .then(function(response) {
        projectManager = response.data;
        projectManagerName = projectManager.ProjectManagerName;
      })
      .catch(console.warn);
  }

  function handleChangeFloorStatus(floorId, selectObject) {
    floorStatus.push({ FloorId: floorId, Value: selectObject.value });
    for (let i = 0; i < floors.length; i++) {
      if (floors[i].FloorId === floorId) {
        floors[i].Status = selectObject.value;
        break;
      }
    }

    floors = floors;
  }

  function getFloors() {
    isFetchingFloors = true;
    axios
      .get(
        "/jobboardapi/GetFloorDetails?jobId=" +
          jobDetail.JobId +
          "&propertyId=" +
          jobDetail.PropertyId +
          "&deliverableId=" +
          jobDetail.DeliverableId +
          "&deliverableItemId=" +
          jobDetail.DeliverableItemId +
          "&prevDeliverableId=" +
          getPrevDeliverableId() +
          "&isEarliestAvailableDeliverable=" +
          isEarliestAvailableDeliverable()
      )
      .then(function(response) {
        floors = response.data;
      })
      .catch(console.warn)
      .finally(function (params) {
        isFetchingFloors = false;
      });
  }

  function isStatusEditingAllowed() {
    return deliverableItemSequenceNo >= MIN_SEQUENCE_NUMBER_TO_ALLOW_STATUS_EDITING;
  }

  function onJobDueDateChanged(evt) {
    dueDate = evt.target.value;
  }

  function onFloorAdded() {
    dispatch('floorChanged');
    getFloors();
  }

  function onFloorEdited() {
    dispatch('floorChanged');
    getFloors();
  }

  function onFloorDeleted() {
    dispatch('floorChanged');
    getFloors();
  }

  function onFloorResourceAssigned() {
    setTimeout(() => {
      dispatch('floorChanged');
      getJobDetail();
      getFloors();
      getContacts();
    }, 10);
  }

  function onResourceUnassigned() {
    setTimeout(() => {
      dispatch('floorChanged');
      getFloors();
      getContacts();
    }, 10);
  }

  function askAutoAddFloorsConfirmation() {
    toggleAutoAddFloorsConfirmationDialog();
  }

  function autoAddFloors() {
    isFetchingFloors = true;

    const bodyFormData = new FormData();
    bodyFormData.set("jobId", jobDetail.JobID);
    bodyFormData.set("propertyId", jobDetail.PropertyId);
    const requestOpts = {
      method: "post",
      url: "/jobboardapi/AutoAddFloors",
      data: bodyFormData,
      headers: { "Content-Type": "multipart/form-data" }
    };

    axios(requestOpts)
      .then(_ => getFloors())
      .catch(console.warn)
      .finally(_ => dispatch('floorChanged'));
  }

  function refreshFloors() {
    getFloors();
  }

  function addMultipleFloors() {
    const sortedOrders = floors.map(e => e.FloorOrder).sort((a, b) => a - b);
    const startingOrder = sortedOrders.length > 0
      ? sortedOrders[sortedOrders.length - 1] + 1
      : 1;

    addMultipleFloorsModal.openModal(startingOrder);
  }

  function isFirstDeliverable() {
    const availableDeliverableItems = getAvailableDeliverableItems();
    const firstDeliverableItem = availableDeliverableItems.sort((a, b) => a.SequenceNumber - b.SequenceNumber)[0];
    if (!!firstDeliverableItem) {
      return firstDeliverableItem.DeliverableItemId === jobDetail.DeliverableItemId;
    }

    return false;
  }

  function isEarliestAvailableDeliverable() {
    const availableDeliverableItems = getAvailableDeliverableItems();
    const jobCards = getJobCards();

    const prevDeliverables = availableDeliverableItems.filter(e => e.SequenceNumber < deliverableItemSequenceNo);
    const hasPrevDeliverables = jobCards.some(e => prevDeliverables.map(f => f.DeliverableItemId).includes(e.DeliverableItemId));

    return !hasPrevDeliverables;
  }

  function getPrevDeliverableId() {
    const availableDeliverableItems = getAvailableDeliverableItems();
    const jobCards = getJobCards();

    const prevDeliverableItems = availableDeliverableItems.filter(e => e.SequenceNumber < deliverableItemSequenceNo);
    if (prevDeliverableItems.length <= 0) {
      return '';
    }

    const prevDeliverableItem = prevDeliverableItems[prevDeliverableItems.length - 1];

    const prevDeliverable = jobCards.find(e => e.DeliverableItemId === prevDeliverableItem.DeliverableItemId);
    if (!prevDeliverable) {
      return '';
    }

    return prevDeliverable.DeliverableId;
  }

  function onContactChanged() {
    loadData();
  }

</script>

<style>
  select {
    width: 100%;
    padding: 5px 10px;
    border-radius: 5px;
    border: 1px solid #b2bec3;
  }
  input {
    width: 100%;
    padding: 5px 10px;
    border-radius: 5px;
    border: 1px solid #b2bec3;
    background-color: white;
  }
  .modal-row {
    display: flex;
    margin-bottom: 15px;
  }
  .field-container {
    width: 100%;
    margin: 0px 10px;
  }
  .project-manager {
    font-size: 17px;
    padding-top: 5px;
  }
  .member-name-list {
    display: flex;
    margin-top: 10px;
    width: 100%;
  }

  .member-name-list > *:not(:first-child) {
    margin-left: 4px;
  }

  @media (max-width: 426px) {
    .modal-row {
      display: block;
    }

    .modal-body {
      padding: 10px;
    }
    .field-container {
      margin: 0 0 10px 0;
    }
    .modal-row table tr {
      display: flex;
      text-align: left;
    }
    .table td,
    .table th {
      flex: 1;
      text-align: left;
    }
    .floor-section table select {
      width: auto !important;
    }
    .member-name-list {
      position: relative;
      display: block;
      padding-bottom: 42px;
    }
    .project-manager {
      position: absolute;
      bottom: 20px;
      left: 8px;
    }
  }
  .title-top {
    width: 100%;
    display: flex;
  }
  .title-top span {
    flex: 1;
    padding-right: 50px;
  }
  .title-top span:nth-child(2) {
    text-align: right;
  }
  @media (max-width: 768px) {
    .title-top span {
      padding-right: 0;
    }
  }
  .fa-edit {
    color: #ffc107;
    position: relative;
    margin-right: 18px;
  }
  .fa-trash {
    color: #e34724;
    position: relative;
  }

  .fa-edit:hover .tooltiptext {
    visibility: visible;
  }
  .fa-trash:hover .tooltiptext {
    visibility: visible;
  }
  .tooltiptext {
    visibility: hidden;
    width: 47px;
    background-color: #000;
    color: #fff;
    text-align: center;
    border-radius: 2px;
    padding: 5px 0;
    position: absolute;
    z-index: 1;
    bottom: 100%;
    left: 50%;
    margin-left: -21px;
    font-size: 11px;
  }

  .floor-section-header {
    display: flex;
    align-items: center;
  }

  .floor-section-header > div:first-child {
    flex-grow: 1;
  }

  :global(.edit-jobs-modal .modal-title) {
    width: 100%;
  }

  .title-top input[type=date] {
    height: 2rem;
    width: 200px;
  }
</style>

<div class="edit-jobs-modal">
  <Modal isOpen={open} {toggle} size="lg" class="timesheet-edit-job-modal">
    <ModalHeader
      {toggle}
      class="timesheet-modal-title"
      style="display: flex !important">
      <div class="title-top">
        <span>{(jobDetail.JobName || '')}</span>
        <!-- <span>
          Job Due Date: {dueDate === 'NaN/NaN/NaN' ? ' Empty' : dueDate}
        </span> -->
        <span>
          Job Due Date: <input type="date" value={dueDateHtmlFormat} on:change={onJobDueDateChanged} />
        </span>
      </div>
      <span style="margin-left: 130px">
        <span>
          <div class="member-name-list">
            <button
              on:click={toggleAddContact}
              style="border: none; border-radius: 50%; padding: 10px;height:44px">
              <Icon data={userPlus} scale={1.5} />
            </button>
            {#if isFetchingContacts}
              <center>
                <div style="display: flex; width: 60%">
                  <div style="margin: 0 auto">
                    <Spinner type="grow" size="sm" />
                  </div>
                  <div style="margin: 0 auto">
                    <Spinner type="grow" size="sm" />
                  </div>
                  <div style="margin: 0 auto">
                    <Spinner type="grow" size="sm" />
                  </div>
                  <div style="margin: 0 auto">
                    <Spinner type="grow" size="sm" />
                  </div>
                </div>
              </center>
            {:else}
              <h5>
                {#each contacts as contact}
                  <JobContactsContainer
                    fullname={contact.FullName}
                    resourceId={contact.ContactId}
                    deliverableId={jobDetail.DeliverableId}
                    resourceType={contact.Type}
                    on:resourceUnassigned={onResourceUnassigned} />
                {/each}
              </h5>
            {/if}
            {#if projectManagerName != null}
              <div class="project-manager">
                {#if projectManagerName != null}
                  <Badge style="padding-right: 4px;" pill>
                    {projectManagerName} - PM
                  </Badge>

                  <DeleteProjectManagerModal
                    open={openDeleteProjectManager}
                    toggle={toggleDeleteProjectManager}
                    name={projectManagerName}
                    jobId={jobDetail.JobID}
                    deliverableId={jobDetail.DeliverableId} />
                {/if}
              </div>
            {/if}
          </div>
        </span>
      </span>
    </ModalHeader>
    <ModalBody>
      {#if isFetching}
        <center>
          <Spinner size="md" style="width: 80px; height: 80px;" />
        </center>
      {:else}
        <div class="modal-row">
          <div class="field-container">
            <h6>Deliverable</h6>
            <div
              style="width: 100%; padding: 5px 10px; border-radius: 5px; border:
              1px solid #b2bec3; background-color: white;">
              {jobDetail.DeliverableItemName || ''}&nbsp;
            </div>
          </div>
          <div class="field-container">
            <h6>Priority</h6>
            <select name="" id="" bind:value={jobDetail.Priority}>
              {#each priorityOptions as priority}
                <option
                  value={priority.Value}
                  selected={priority.Value === Priority ? true : false}>
                  {priority.Label}
                </option>
              {/each}
            </select>
          </div>
          <div class="field-container">
            <h6>Status</h6>
            <select name="" id="" bind:value={jobDetail.Status} disabled={!formOptions.allowStatusEditing}>
              {#each statusOptions as stats}
                <option
                  value={stats.Value}
                  selected={stats.Value === jobDetail.Status ? true : false}>
                  {stats.Label}
                </option>
              {/each}
            </select>
          </div>
        </div>
        <div class="modal-row">
          <div class="field-container">
            <h6>Start Date</h6>
            <input
              type="date"
              disabled={true}
              bind:value={startdate}
              on:change={handleChangeStartDate}
              style="cursor: not-allowed !important" />
          </div>
          <div class="field-container">
            <h6>Due Date</h6>
            <input
              type="date"
              disabled={true}
              bind:value={enddate}
              on:change={handleChangeEndDate}
              style="cursor: not-allowed !important" />
          </div>
        </div>
        <div class="modal-row">
          <div class="field-container">
            <h6>Job Notes</h6>
            <Input
              type="textarea"
              name="text"
              bind:value={jobDetail.FormattedNotes}
              style="height: 100px"
              disabled={editJob ? false : true} />
          </div>
        </div>
        <div class="modal-row">
          <div class="field-container floor-section">
            <div class="floor-section-header">
              <div>
                <h6>Floors</h6>
                {#if jobDetail.Floors != null}
                  <p>Completed: {completedFloorsCount} of {floorsCount}</p>
                {/if}
              </div>
              <div>
                <Button disabled={isFetchingFloors} on:click={askAutoAddFloorsConfirmation}>Auto-add Floors</Button>
                <Button disabled={isFetchingFloors} on:click={addMultipleFloors}>Add Floors</Button>
                <Button class="fetch-floors-button" disabled={isFetchingFloors} on:click={refreshFloors}>
                  {#if isFetchingFloors}
                    <Spinner size="sm" />
                  {/if}
                  Refresh
                </Button>
              </div>
            </div>
            {#if isFetchingFloors}
              <center>
                <div style="display: flex; width: 60%">
                  <div style="margin: 0 auto">
                    <Spinner type="grow" size="sm" />
                  </div>
                  <div style="margin: 0 auto">
                    <Spinner type="grow" size="sm" />
                  </div>
                  <div style="margin: 0 auto">
                    <Spinner type="grow" size="sm" />
                  </div>
                  <div style="margin: 0 auto">
                    <Spinner type="grow" size="sm" />
                  </div>
                  <div style="margin: 0 auto">
                    <Spinner type="grow" size="sm" />
                  </div>
                </div>
              </center>
            {:else if floors != null}
              <Table hover>
                <thead>
                  <tr>
                    <th>Status</th>
                    <th>Floor Number</th>
                    <th>Notes</th>
                    <th>Floor Order</th>
                    <th>Resource Assigned</th>
                    <th>Action</th>
                  </tr>
                </thead>
                <tbody>
                  {#each floors as floor}
                    <tr
                      style={floor.Show === 'False' ? 'background-color:#ecf0f1;color:#bdc3c7' : ''}>
                      <th scope="row">
                        {#if floor.Show !== 'False'}
                          <select
                            id={floor.FloorId}
                            disabled={!floor.ResourceId || !floor.ResourceName}
                            on:change={handleChangeFloorStatus(floor.FloorId, this)}>
                            {#if floorStatusOptions != null}
                              {#each floorStatusOptions as floorStatus}
                                <option
                                  value={floorStatus.FloorStatusValue}
                                  selected={floor.Status == floorStatus.FloorStatusValue}>
                                  {floorStatus.FloorStatusName}
                                </option>
                              {/each}
                            {/if}
                          </select>
                        {/if}
                      </th>
                      <th>{floor.FloorLabel}</th>
                      <td>{floor.Notes}</td>
                      <td>{floor.FloorOrder}</td>
                      {#if !!floor.ResourceGroup && floor.ResourceGroup.length > 0}
                        <td>
                          {#each floor.ResourceGroup.map(e => e.ResourceName).filter(e => !!e) as resourceName}
                            {resourceName}
                            <br>
                          {/each}
                        </td>
                      {:else}
                        {#if floor.ResourceName === null}
                          <td>
                            {#if floor.Show === 'False'}
                              <button style="border: none;" disabled>
                                <Icon data={userPlus} scale={1} />
                              </button>
                            {:else}
                              <AddFloorResource
                                floorname={floor.FloorLabel}
                                floorid={floor.FloorId}
                                deliverableid={jobDetail.DeliverableId}
                                floorStatus={floor.Status}
                                on:resourceassigned={onFloorResourceAssigned} />
                            {/if}
                          </td>
                        {:else}
                          <td>{floor.ResourceName}</td>
                        {/if}
                      {/if}

                      <td>

                        <div class="edit">
                          {#if floor.Show === 'False'}
                            <Button on:click={handleEditFloor(floor)} disabled>
                              <i class="far fa-edit">
                                <span class="tooltiptext">Edit</span>
                              </i>
                            </Button>
                          {:else}
                            <Button on:click={handleEditFloor(floor)}>
                              <i class="far fa-edit">
                                <span class="tooltiptext">Edit</span>
                              </i>
                            </Button>
                          {/if}
                        </div>
                        <div class="delete">
                          <Button
                            color="danger"
                            on:click={handleDeleteFloor(floor.FloorId, floor.FloorName)}>
                            <i class="fas fa-trash">
                              <span class="tooltiptext">Delete</span>
                            </i>
                          </Button>
                        </div>
                      </td>
                    </tr>
                  {/each}

                  <tr />
                </tbody>
              </Table>
            {/if}
          </div>
        </div>
        <!-- <div style="margin: 15px auto">
              <Icon data={eye} scale={1.5} style="margin-top:-5px" />
              Show add floor
            </div> -->
        <hr />
        <div style="padding: 20px; width: 100%; margin-bottom: 15px ">
          <div>
            <div style="display: flex; margin-bottom: 10px">
              <input
                class="col-two"
                bind:value={floorName}
                type="text"
                placeholder="Floor Number"
                style="margin-right: 10px" />
              <input
                class="col-two"
                bind:value={floorOrder}
                type="number"
                placeholder="Order" />
            </div>
            <Input
              bind:value={floorNotes}
              type="textarea"
              name="text"
              id="exampleText"
              placeholder="Notes"
              style="margin-bottom: 10px" />
          </div>
          <button
            style="margin-left: auto"
            on:click={AddFloor}
            disabled={floorName === '' || floorOrder === 0 ? true : false}>
            Add Floor
          </button>
        </div>
        <hr />
        <div class="modal-row">
          <div class="field-container">
            <h6>Deliverable Comments</h6>
            <Input
              type="textarea"
              name="text"
              placeholder="Notes"
              style="height: 100px"
              disabled={editJob ? false : true}
              bind:value={deliverableComments} />
          </div>
        </div>
      {/if}
    </ModalBody>
    <ModalFooter>
      {#if saving}
        <Button color="primary" disabled style="cursor: not-allowed">
          <Spinner size="sm" />
          Saving
        </Button>
      {:else}
        <Button color="primary" on:click={async () => UpdateJobs()}>Save</Button>
      {/if}
      <Button color="secondary" on:click={toggle}>Cancel</Button>
    </ModalFooter>
  </Modal>
</div>
<AddFloorModal
  open={openAddFloor}
  toggle={toggleAddFloor}
  propertyId={jobDetail.PropertyId}
  deliverableId={jobDetail.DeliverableId} />
<AddContactModal
  open={openAddContact}
  toggle={toggleAddContact}
  {teamId}
  data={jobDetail}
  on:contactUpdated={onContactChanged} />
<DeleteFloorModal
  open={openDeleteFloor}
  toggle={toggleDeleteFloor}
  id={deletefloor_id}
  name={deletefloor_name}
  deliverableId={jobDetail.DeliverableId}
  on:completed={onFloorDeleted} />

<EditFloorsModal
  open={openEditFloor}
  toggle={toggleEditFloor}
  {floorDetails}
  deliverableId={jobDetail.DeliverableId}
  deliverableItemId={jobDetail.DeliverableItemId}
  jobId={jobDetail.JobID}
  on:completed={onFloorEdited} />

<AddMultipleFloorsModal
  bind:this={addMultipleFloorsModal}
  propertyId={jobDetail.PropertyId}
  on:completed={onFloorAdded} />


<ConfirmationDialog
  open={isAutoAddFloorsConfirmationDialogOpen}
  toggle={toggleAutoAddFloorsConfirmationDialog}
  title="Auto-add Floors"
  message="Are you sure you want to add all Floors?"
  action={autoAddFloors} />
